import { throwError } from '../utils/throwError.js';
export function serializeError(src, type, cause) {
    return throwError('serialize', src, type, cause);
}
//# sourceMappingURL=serializeError.js.map